module.exports = __webpack_public_path__ + "static/media/stblogo.43da81ef.svg";